/**
 * Links to sibling products that live outside this app.
 *
 * Kept in one module so a URL change is a single edit, and so every entry point
 * opens them the same way. Two surfaces link to Rover today: the sidebar item
 * and the Spatial Brief header.
 */

export const ROVER_URL = 'https://pms.inditechapps.com';

/**
 * Open an external product in a new tab.
 *
 * noopener/noreferrer are not optional here: a bare target=_blank hands the
 * opened page a live `window.opener` handle, which lets it navigate this app to
 * a look-alike login while the user is looking at the other tab.
 */
export function openExternalApp(url) {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
}
